import { useContentHostId, useContentLanguagesApi } from "./NautilusApiContext.ts";

export const useContentLanguagesForContentApi = () => {
  const api = useContentLanguagesApi();
  const hostId = useContentHostId();
  return {
    queryKey: api.getQueryKey(hostId),
    getAll: () => api.getAll({ params: { hostId } }),
    add: (contentLanguage: Parameters<typeof api.add>[0]) => api.add(contentLanguage, { params: { hostId } }),
    update: ({ code, ...payload }: Parameters<typeof api.update>[0] & { code: string }) =>
      api.update(payload, { params: { hostId, lang: code } }),
  };
};

export type ContentLanguagesForContentApi = ReturnType<typeof useContentLanguagesForContentApi>;
